export default __webpack_public_path__ + "static/media/usd-coin-usdc-logo.8634899b.svg";